/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMunicipalCreateMunicipalPost } from '../fn/municipal/api-municipal-create-municipal-post';
import { ApiMunicipalCreateMunicipalPost$Params } from '../fn/municipal/api-municipal-create-municipal-post';
import { apiMunicipalCreateMunicipalPost$Plain } from '../fn/municipal/api-municipal-create-municipal-post-plain';
import { ApiMunicipalCreateMunicipalPost$Plain$Params } from '../fn/municipal/api-municipal-create-municipal-post-plain';
import { apiMunicipalDeleteMunicipalDelete } from '../fn/municipal/api-municipal-delete-municipal-delete';
import { ApiMunicipalDeleteMunicipalDelete$Params } from '../fn/municipal/api-municipal-delete-municipal-delete';
import { apiMunicipalDeleteMunicipalDelete$Plain } from '../fn/municipal/api-municipal-delete-municipal-delete-plain';
import { ApiMunicipalDeleteMunicipalDelete$Plain$Params } from '../fn/municipal/api-municipal-delete-municipal-delete-plain';
import { apiMunicipalGetMunicipalGet } from '../fn/municipal/api-municipal-get-municipal-get';
import { ApiMunicipalGetMunicipalGet$Params } from '../fn/municipal/api-municipal-get-municipal-get';
import { apiMunicipalGetMunicipalGet$Plain } from '../fn/municipal/api-municipal-get-municipal-get-plain';
import { ApiMunicipalGetMunicipalGet$Plain$Params } from '../fn/municipal/api-municipal-get-municipal-get-plain';
import { apiMunicipalGetMunicipalsGet } from '../fn/municipal/api-municipal-get-municipals-get';
import { ApiMunicipalGetMunicipalsGet$Params } from '../fn/municipal/api-municipal-get-municipals-get';
import { apiMunicipalGetMunicipalsGet$Plain } from '../fn/municipal/api-municipal-get-municipals-get-plain';
import { ApiMunicipalGetMunicipalsGet$Plain$Params } from '../fn/municipal/api-municipal-get-municipals-get-plain';
import { apiMunicipalUpdateMunicipalPatch } from '../fn/municipal/api-municipal-update-municipal-patch';
import { ApiMunicipalUpdateMunicipalPatch$Params } from '../fn/municipal/api-municipal-update-municipal-patch';
import { apiMunicipalUpdateMunicipalPatch$Plain } from '../fn/municipal/api-municipal-update-municipal-patch-plain';
import { ApiMunicipalUpdateMunicipalPatch$Plain$Params } from '../fn/municipal/api-municipal-update-municipal-patch-plain';
import { CreateMunicipalCommandResult } from '../models/create-municipal-command-result';
import { DeleteMunicipalCommandResult } from '../models/delete-municipal-command-result';
import { GetAllMunicipalsQueryResult } from '../models/get-all-municipals-query-result';
import { GetMunicipalQueryResult } from '../models/get-municipal-query-result';
import { UpdateMunicipalCommandResult } from '../models/update-municipal-command-result';

@Injectable({ providedIn: 'root' })
export class MunicipalService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMunicipalGetMunicipalGet()` */
  static readonly ApiMunicipalGetMunicipalGetPath = '/api/Municipal/GetMunicipal';

  /**
   * Get details of a specific municipal by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalGetMunicipalGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalGet$Plain$Response(params?: ApiMunicipalGetMunicipalGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMunicipalQueryResult>> {
    return apiMunicipalGetMunicipalGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get details of a specific municipal by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalGetMunicipalGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalGet$Plain(params?: ApiMunicipalGetMunicipalGet$Plain$Params, context?: HttpContext): Observable<GetMunicipalQueryResult> {
    return this.apiMunicipalGetMunicipalGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMunicipalQueryResult>): GetMunicipalQueryResult => r.body)
    );
  }

  /**
   * Get details of a specific municipal by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalGetMunicipalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalGet$Response(params?: ApiMunicipalGetMunicipalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMunicipalQueryResult>> {
    return apiMunicipalGetMunicipalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get details of a specific municipal by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalGetMunicipalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalGet(params?: ApiMunicipalGetMunicipalGet$Params, context?: HttpContext): Observable<GetMunicipalQueryResult> {
    return this.apiMunicipalGetMunicipalGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetMunicipalQueryResult>): GetMunicipalQueryResult => r.body)
    );
  }

  /** Path part for operation `apiMunicipalGetMunicipalsGet()` */
  static readonly ApiMunicipalGetMunicipalsGetPath = '/api/Municipal/GetMunicipals';

  /**
   * Get all municipals with pagination and filtering options.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalGetMunicipalsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalsGet$Plain$Response(params?: ApiMunicipalGetMunicipalsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllMunicipalsQueryResult>> {
    return apiMunicipalGetMunicipalsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all municipals with pagination and filtering options.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalGetMunicipalsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalsGet$Plain(params?: ApiMunicipalGetMunicipalsGet$Plain$Params, context?: HttpContext): Observable<GetAllMunicipalsQueryResult> {
    return this.apiMunicipalGetMunicipalsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllMunicipalsQueryResult>): GetAllMunicipalsQueryResult => r.body)
    );
  }

  /**
   * Get all municipals with pagination and filtering options.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalGetMunicipalsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalsGet$Response(params?: ApiMunicipalGetMunicipalsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllMunicipalsQueryResult>> {
    return apiMunicipalGetMunicipalsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all municipals with pagination and filtering options.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalGetMunicipalsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMunicipalGetMunicipalsGet(params?: ApiMunicipalGetMunicipalsGet$Params, context?: HttpContext): Observable<GetAllMunicipalsQueryResult> {
    return this.apiMunicipalGetMunicipalsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetAllMunicipalsQueryResult>): GetAllMunicipalsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiMunicipalCreateMunicipalPost()` */
  static readonly ApiMunicipalCreateMunicipalPostPath = '/api/Municipal/CreateMunicipal';

  /**
   * Create a new municipal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalCreateMunicipalPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalCreateMunicipalPost$Plain$Response(params?: ApiMunicipalCreateMunicipalPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMunicipalCommandResult>> {
    return apiMunicipalCreateMunicipalPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new municipal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalCreateMunicipalPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalCreateMunicipalPost$Plain(params?: ApiMunicipalCreateMunicipalPost$Plain$Params, context?: HttpContext): Observable<CreateMunicipalCommandResult> {
    return this.apiMunicipalCreateMunicipalPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateMunicipalCommandResult>): CreateMunicipalCommandResult => r.body)
    );
  }

  /**
   * Create a new municipal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalCreateMunicipalPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalCreateMunicipalPost$Response(params?: ApiMunicipalCreateMunicipalPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateMunicipalCommandResult>> {
    return apiMunicipalCreateMunicipalPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new municipal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalCreateMunicipalPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalCreateMunicipalPost(params?: ApiMunicipalCreateMunicipalPost$Params, context?: HttpContext): Observable<CreateMunicipalCommandResult> {
    return this.apiMunicipalCreateMunicipalPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateMunicipalCommandResult>): CreateMunicipalCommandResult => r.body)
    );
  }

  /** Path part for operation `apiMunicipalUpdateMunicipalPatch()` */
  static readonly ApiMunicipalUpdateMunicipalPatchPath = '/api/Municipal/UpdateMunicipal';

  /**
   * Update an existing municipal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalUpdateMunicipalPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalUpdateMunicipalPatch$Plain$Response(params?: ApiMunicipalUpdateMunicipalPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMunicipalCommandResult>> {
    return apiMunicipalUpdateMunicipalPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing municipal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalUpdateMunicipalPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalUpdateMunicipalPatch$Plain(params?: ApiMunicipalUpdateMunicipalPatch$Plain$Params, context?: HttpContext): Observable<UpdateMunicipalCommandResult> {
    return this.apiMunicipalUpdateMunicipalPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateMunicipalCommandResult>): UpdateMunicipalCommandResult => r.body)
    );
  }

  /**
   * Update an existing municipal.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalUpdateMunicipalPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalUpdateMunicipalPatch$Response(params?: ApiMunicipalUpdateMunicipalPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateMunicipalCommandResult>> {
    return apiMunicipalUpdateMunicipalPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an existing municipal.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalUpdateMunicipalPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalUpdateMunicipalPatch(params?: ApiMunicipalUpdateMunicipalPatch$Params, context?: HttpContext): Observable<UpdateMunicipalCommandResult> {
    return this.apiMunicipalUpdateMunicipalPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateMunicipalCommandResult>): UpdateMunicipalCommandResult => r.body)
    );
  }

  /** Path part for operation `apiMunicipalDeleteMunicipalDelete()` */
  static readonly ApiMunicipalDeleteMunicipalDeletePath = '/api/Municipal/DeleteMunicipal';

  /**
   * Delete a municipal by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalDeleteMunicipalDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalDeleteMunicipalDelete$Plain$Response(params?: ApiMunicipalDeleteMunicipalDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMunicipalCommandResult>> {
    return apiMunicipalDeleteMunicipalDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a municipal by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalDeleteMunicipalDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalDeleteMunicipalDelete$Plain(params?: ApiMunicipalDeleteMunicipalDelete$Plain$Params, context?: HttpContext): Observable<DeleteMunicipalCommandResult> {
    return this.apiMunicipalDeleteMunicipalDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteMunicipalCommandResult>): DeleteMunicipalCommandResult => r.body)
    );
  }

  /**
   * Delete a municipal by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMunicipalDeleteMunicipalDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalDeleteMunicipalDelete$Response(params?: ApiMunicipalDeleteMunicipalDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteMunicipalCommandResult>> {
    return apiMunicipalDeleteMunicipalDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a municipal by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMunicipalDeleteMunicipalDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiMunicipalDeleteMunicipalDelete(params?: ApiMunicipalDeleteMunicipalDelete$Params, context?: HttpContext): Observable<DeleteMunicipalCommandResult> {
    return this.apiMunicipalDeleteMunicipalDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteMunicipalCommandResult>): DeleteMunicipalCommandResult => r.body)
    );
  }

}
